import { extendTheme, theme as base } from "@chakra-ui/react";

import { ButtonStyle as Button } from "./ButtonStyle";
import { TextStyle as Text } from "./Text";
import { TextAreaStyle as Textarea } from "./TextArea";
const CustomTheme = extendTheme({
  components: {
    Button,
    Textarea,
    Text,
  },
});

export default CustomTheme;
